import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UrlHelperService } from '@ui/global-shared/util/url-helper.service';
import { SupplierRegistrationState } from './supplier-registration-state.model';

@Injectable({
  providedIn: 'root',
})
export class SupplierRegistrationStateService {
  private http = inject(HttpClient);
  private urlHelper = inject(UrlHelperService);

  getRegistrationState(): Observable<SupplierRegistrationState> {
    return this.http.get<SupplierRegistrationState>(
      this.urlHelper.prepareApiPath('registrationstate'),
    );
  }
}
